export default "__VITE_ASSET__BEywk6Iu__"